var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8221 5.54219C18.9652 2.17305 15.9825 0.000976562 12.4996 0L12.0996 0.711621L12.4996 1.46387C15.0618 1.46475 17.3219 3.04058 18.2253 5.37764C18.3158 5.61177 18.3558 5.86978 18.3558 5.86978H19.5995L19.8221 5.54219Z",
    fill: "#04303E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17773 5.54219C6.03467 2.17305 9.01738 0.000976562 12.5003 0V1.46387C9.93809 1.46475 7.67793 3.04058 6.77451 5.37764C6.68403 5.61177 6.64404 5.86978 6.64404 5.86978H5.40039L5.17773 5.54219Z",
    fill: "#07485E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76309 10.367H5.64629C5.2311 10.367 4.89453 10.0305 4.89453 9.61527V6.12938C4.89453 5.7142 5.2311 5.37762 5.64629 5.37762H7.76309C8.17827 5.37762 8.51484 5.7142 8.51484 6.12938L9.23013 6.60844V9.50697L8.51484 9.61532C8.51484 10.0305 8.17827 10.367 7.76309 10.367Z",
    fill: "#0FA8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9895 14.9341H17.9746V13.4692H17.9895C18.3067 13.4692 18.6347 13.4692 18.6347 12.0915V10.367L18.9049 9.71497H20.0996V12.0915C20.0996 12.9127 19.9964 13.4772 19.765 13.9218C19.5247 14.3835 19.0215 14.9341 17.9895 14.9341Z",
    fill: "#04303E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2369 10.367H19.3537C19.7688 10.367 20.1054 10.0305 20.1054 9.61527V6.12938C20.1054 5.7142 19.7688 5.37762 19.3537 5.37762H17.2369C16.8217 5.37762 16.4851 5.7142 16.4851 6.12938L15.7324 6.61322V9.11903L16.4851 9.61532C16.4851 10.0305 16.8217 10.367 17.2369 10.367Z",
    fill: "#0D90BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 17.9683L12.9691 19.9854L12.5003 19.5278L11.3066 16.5693L12.5003 14.3535L12.9055 13.731H14.5521L14.829 14.0586V17.1577L15.2 17.9683Z",
    fill: "#DF9280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80078 17.9683L12.0317 19.9854L12.5005 19.5278V14.3535L12.0953 13.731H10.4487L10.1719 14.0586V17.1577L9.80078 17.9683Z",
    fill: "#F9A58D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4839 6.03662V11.4155C16.4839 12.5747 15.8115 13.5781 14.8359 14.0552C14.833 14.0562 14.8306 14.0576 14.8281 14.0586C14.4409 14.2476 14.0063 14.3525 13.5356 14.3535H12.4995L10.9316 9.43848L12.4995 6.15088L13.3252 5.08105L15.8311 4.71973L16.2407 4.85791C16.2832 4.95898 16.3213 5.06396 16.3545 5.17187C16.4385 5.44531 16.4839 5.73584 16.4839 6.03662Z",
    fill: "#FFBDA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51563 6.03662V11.4155C8.51563 12.5747 9.18799 13.5781 10.1636 14.0552C10.1665 14.0562 10.1689 14.0576 10.1714 14.0586C10.5586 14.2476 10.9932 14.3525 11.4639 14.3535H12.5V6.15088L11.6743 5.08105L9.16846 4.71973L8.75879 4.85791C8.71631 4.95898 8.67822 5.06396 8.64502 5.17187C8.55905 5.45207 8.51544 5.74354 8.51563 6.03662Z",
    fill: "#FFCCBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8279 17.1577H16.2117C21.0647 17.1577 24.9993 20.6685 24.9993 25H12.4993L10.9316 22.5035L12.4993 19.5278C13.7688 19.5278 14.8294 18.4265 14.8279 17.1577H14.8279Z",
    fill: "#0D90BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1714 17.1577C10.1714 18.4268 11.231 19.5278 12.5 19.5278V25H0C0 20.3457 4.41699 17.1577 8.7876 17.1577H10.1714Z",
    fill: "#0FA8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4082 20.478H8.30098V21.9428H5.4082V20.478Z",
    fill: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2409 4.85791C15.2643 5.66113 13.9508 6.14941 12.4997 6.15088L11.6426 4.55142L12.4997 3.09961H13.547C14.8288 3.09961 15.7907 3.78369 16.2409 4.85791Z",
    fill: "#04303E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 3.09961V6.15088C11.0415 6.15088 9.74023 5.68018 8.76172 4.87207C9.2124 3.8291 10.25 3.09961 11.4585 3.09961H12.4995Z",
    fill: "#07485E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.ef9f745ff13f27d878d2b2755ee3f2e4.svg";
export { ForwardRef as ReactComponent };